/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as publicLoginRouteImport } from './routes/(public)/login'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedPlatformRouteRouteImport } from './routes/_authenticated/platform/route'
import { Route as AuthenticatedBillingCreditNotesRouteImport } from './routes/_authenticated/billing/credit-notes'
import { Route as AuthenticatedBillingExchangeRatesRouteImport } from './routes/_authenticated/billing/exchange-rates'
import { Route as AuthenticatedBillingInvoicesRouteRouteImport } from './routes/_authenticated/billing/invoices/route'
import { Route as AuthenticatedBillingPaymentMethodsRouteImport } from './routes/_authenticated/billing/payment-methods'
import { Route as AuthenticatedBillingPaymentsRouteRouteImport } from './routes/_authenticated/billing/payments/route'
import { Route as AuthenticatedCmsContentRouteRouteImport } from './routes/_authenticated/cms/content/route'
import { Route as AuthenticatedCmsMediaRouteImport } from './routes/_authenticated/cms/media'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedExhibitionCompaniesRouteRouteImport } from './routes/_authenticated/exhibition/companies/route'
import { Route as AuthenticatedExhibitionExhibitorsRouteRouteImport } from './routes/_authenticated/exhibition/exhibitors/route'
import { Route as AuthenticatedExhibitionFloorRouteImport } from './routes/_authenticated/exhibition/floor'
import { Route as AuthenticatedExhibitionServiceItemsRouteImport } from './routes/_authenticated/exhibition/service-items'
import { Route as AuthenticatedExhibitionServiceOrdersRouteRouteImport } from './routes/_authenticated/exhibition/service-orders/route'
import { Route as AuthenticatedExhibitionServiceTermsRouteImport } from './routes/_authenticated/exhibition/service-terms'
import { Route as AuthenticatedPlatformIndexRouteImport } from './routes/_authenticated/platform/index'
import { Route as AuthenticatedPlatformActivityRouteImport } from './routes/_authenticated/platform/activity'
import { Route as AuthenticatedPlatformPaymentMethodsRouteImport } from './routes/_authenticated/platform/payment-methods'
import { Route as AuthenticatedPlatformPlansRouteRouteImport } from './routes/_authenticated/platform/plans/route'
import { Route as AuthenticatedPlatformSeriesRouteRouteImport } from './routes/_authenticated/platform/series/route'
import { Route as AuthenticatedPlatformTenantsRouteRouteImport } from './routes/_authenticated/platform/tenants/route'
import { Route as AuthenticatedPlatformUsageRouteImport } from './routes/_authenticated/platform/usage'
import { Route as AuthenticatedPlatformUsersRouteRouteImport } from './routes/_authenticated/platform/users/route'
import { Route as AuthenticatedProgramMeetingsRouteImport } from './routes/_authenticated/program/meetings'
import { Route as AuthenticatedProgramRoomsRouteImport } from './routes/_authenticated/program/rooms'
import { Route as AuthenticatedProgramSessionsRouteImport } from './routes/_authenticated/program/sessions'
import { Route as AuthenticatedProgramSpeakersRouteImport } from './routes/_authenticated/program/speakers'
import { Route as AuthenticatedSettingsMembersRouteImport } from './routes/_authenticated/settings/members'
import { Route as AuthenticatedSettingsOrganizationRouteImport } from './routes/_authenticated/settings/organization'
import { Route as AuthenticatedSettingsRolesRouteImport } from './routes/_authenticated/settings/roles'
import { Route as AuthenticatedSettingsThemeRouteImport } from './routes/_authenticated/settings/theme'
import { Route as AuthenticatedTicketingCheckInRouteImport } from './routes/_authenticated/ticketing/check-in'
import { Route as AuthenticatedTicketingDeskRouteImport } from './routes/_authenticated/ticketing/desk'
import { Route as AuthenticatedTicketingRegistrationFormRouteImport } from './routes/_authenticated/ticketing/registration-form'
import { Route as AuthenticatedTicketingRegistrationsRouteRouteImport } from './routes/_authenticated/ticketing/registrations/route'
import { Route as AuthenticatedTicketingTicketTypesRouteImport } from './routes/_authenticated/ticketing/ticket-types'
import { Route as AuthenticatedTicketingVouchersRouteImport } from './routes/_authenticated/ticketing/vouchers'
import { Route as AuthenticatedVotingIndexRouteImport } from './routes/_authenticated/voting/index'
import { Route as AuthenticatedBillingInvoicesIndexRouteImport } from './routes/_authenticated/billing/invoices/index'
import { Route as AuthenticatedBillingInvoicesInvoiceIdRouteImport } from './routes/_authenticated/billing/invoices/$invoiceId'
import { Route as AuthenticatedBillingPaymentsIndexRouteImport } from './routes/_authenticated/billing/payments/index'
import { Route as AuthenticatedBillingPaymentsPaymentIdRouteImport } from './routes/_authenticated/billing/payments/$paymentId'
import { Route as AuthenticatedCmsContentIndexRouteImport } from './routes/_authenticated/cms/content/index'
import { Route as AuthenticatedCmsContentIdRouteImport } from './routes/_authenticated/cms/content/$id'
import { Route as AuthenticatedExhibitionCompaniesIndexRouteImport } from './routes/_authenticated/exhibition/companies/index'
import { Route as AuthenticatedExhibitionCompaniesCompanyIdRouteImport } from './routes/_authenticated/exhibition/companies/$companyId'
import { Route as AuthenticatedExhibitionExhibitorsIndexRouteImport } from './routes/_authenticated/exhibition/exhibitors/index'
import { Route as AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteImport } from './routes/_authenticated/exhibition/exhibitors/$applicationId/route'
import { Route as AuthenticatedExhibitionExhibitorsNewRouteImport } from './routes/_authenticated/exhibition/exhibitors/new'
import { Route as AuthenticatedExhibitionServiceOrdersIndexRouteImport } from './routes/_authenticated/exhibition/service-orders/index'
import { Route as AuthenticatedExhibitionServiceOrdersServiceOrderIdRouteImport } from './routes/_authenticated/exhibition/service-orders/$serviceOrderId'
import { Route as AuthenticatedExhibitionServiceOrdersNewRouteImport } from './routes/_authenticated/exhibition/service-orders/new'
import { Route as AuthenticatedPlatformPlansIndexRouteImport } from './routes/_authenticated/platform/plans/index'
import { Route as AuthenticatedPlatformPlansPlanIdRouteImport } from './routes/_authenticated/platform/plans/$planId'
import { Route as AuthenticatedPlatformSeriesIndexRouteImport } from './routes/_authenticated/platform/series/index'
import { Route as AuthenticatedPlatformSeriesSeriesIdRouteImport } from './routes/_authenticated/platform/series/$seriesId'
import { Route as AuthenticatedPlatformTenantsIndexRouteImport } from './routes/_authenticated/platform/tenants/index'
import { Route as AuthenticatedPlatformTenantsTenantIdRouteRouteImport } from './routes/_authenticated/platform/tenants/$tenantId/route'
import { Route as AuthenticatedPlatformUsersIndexRouteImport } from './routes/_authenticated/platform/users/index'
import { Route as AuthenticatedPlatformUsersUserIdRouteImport } from './routes/_authenticated/platform/users/$userId'
import { Route as AuthenticatedTicketingRegistrationsIndexRouteImport } from './routes/_authenticated/ticketing/registrations/index'
import { Route as AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteImport } from './routes/_authenticated/ticketing/registrations/$registrationId/route'
import { Route as AuthenticatedTicketingRegistrationsImportRouteImport } from './routes/_authenticated/ticketing/registrations/import'
import { Route as AuthenticatedExhibitionExhibitorsApplicationIdIndexRouteImport } from './routes/_authenticated/exhibition/exhibitors/$applicationId/index'
import { Route as AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRouteImport } from './routes/_authenticated/exhibition/service-orders/$serviceOrderId_.edit'
import { Route as AuthenticatedPlatformTenantsTenantIdIndexRouteImport } from './routes/_authenticated/platform/tenants/$tenantId/index'
import { Route as AuthenticatedPlatformTenantsTenantIdActivityRouteImport } from './routes/_authenticated/platform/tenants/$tenantId/activity'
import { Route as AuthenticatedPlatformTenantsTenantIdDomainsRouteImport } from './routes/_authenticated/platform/tenants/$tenantId/domains'
import { Route as AuthenticatedPlatformTenantsTenantIdModulesRouteImport } from './routes/_authenticated/platform/tenants/$tenantId/modules'
import { Route as AuthenticatedPlatformTenantsTenantIdUsageRouteImport } from './routes/_authenticated/platform/tenants/$tenantId/usage'
import { Route as AuthenticatedTicketingRegistrationsRegistrationIdIndexRouteImport } from './routes/_authenticated/ticketing/registrations/$registrationId/index'
import { Route as AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRouteImport } from './routes/_authenticated/ticketing/registrations/$registrationId/add-participants'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/(public)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPlatformRouteRoute =
  AuthenticatedPlatformRouteRouteImport.update({
    id: '/platform',
    path: '/platform',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingCreditNotesRoute =
  AuthenticatedBillingCreditNotesRouteImport.update({
    id: '/billing/credit-notes',
    path: '/billing/credit-notes',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingExchangeRatesRoute =
  AuthenticatedBillingExchangeRatesRouteImport.update({
    id: '/billing/exchange-rates',
    path: '/billing/exchange-rates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingInvoicesRouteRoute =
  AuthenticatedBillingInvoicesRouteRouteImport.update({
    id: '/billing/invoices',
    path: '/billing/invoices',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingPaymentMethodsRoute =
  AuthenticatedBillingPaymentMethodsRouteImport.update({
    id: '/billing/payment-methods',
    path: '/billing/payment-methods',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingPaymentsRouteRoute =
  AuthenticatedBillingPaymentsRouteRouteImport.update({
    id: '/billing/payments',
    path: '/billing/payments',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCmsContentRouteRoute =
  AuthenticatedCmsContentRouteRouteImport.update({
    id: '/cms/content',
    path: '/cms/content',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCmsMediaRoute = AuthenticatedCmsMediaRouteImport.update({
  id: '/cms/media',
  path: '/cms/media',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExhibitionCompaniesRouteRoute =
  AuthenticatedExhibitionCompaniesRouteRouteImport.update({
    id: '/exhibition/companies',
    path: '/exhibition/companies',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExhibitionExhibitorsRouteRoute =
  AuthenticatedExhibitionExhibitorsRouteRouteImport.update({
    id: '/exhibition/exhibitors',
    path: '/exhibition/exhibitors',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExhibitionFloorRoute =
  AuthenticatedExhibitionFloorRouteImport.update({
    id: '/exhibition/floor',
    path: '/exhibition/floor',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExhibitionServiceItemsRoute =
  AuthenticatedExhibitionServiceItemsRouteImport.update({
    id: '/exhibition/service-items',
    path: '/exhibition/service-items',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExhibitionServiceOrdersRouteRoute =
  AuthenticatedExhibitionServiceOrdersRouteRouteImport.update({
    id: '/exhibition/service-orders',
    path: '/exhibition/service-orders',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExhibitionServiceTermsRoute =
  AuthenticatedExhibitionServiceTermsRouteImport.update({
    id: '/exhibition/service-terms',
    path: '/exhibition/service-terms',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPlatformIndexRoute =
  AuthenticatedPlatformIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPlatformRouteRoute,
  } as any)
const AuthenticatedPlatformActivityRoute =
  AuthenticatedPlatformActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedPlatformRouteRoute,
  } as any)
const AuthenticatedPlatformPaymentMethodsRoute =
  AuthenticatedPlatformPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => AuthenticatedPlatformRouteRoute,
  } as any)
const AuthenticatedPlatformPlansRouteRoute =
  AuthenticatedPlatformPlansRouteRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => AuthenticatedPlatformRouteRoute,
  } as any)
const AuthenticatedPlatformSeriesRouteRoute =
  AuthenticatedPlatformSeriesRouteRouteImport.update({
    id: '/series',
    path: '/series',
    getParentRoute: () => AuthenticatedPlatformRouteRoute,
  } as any)
const AuthenticatedPlatformTenantsRouteRoute =
  AuthenticatedPlatformTenantsRouteRouteImport.update({
    id: '/tenants',
    path: '/tenants',
    getParentRoute: () => AuthenticatedPlatformRouteRoute,
  } as any)
const AuthenticatedPlatformUsageRoute =
  AuthenticatedPlatformUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedPlatformRouteRoute,
  } as any)
const AuthenticatedPlatformUsersRouteRoute =
  AuthenticatedPlatformUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedPlatformRouteRoute,
  } as any)
const AuthenticatedProgramMeetingsRoute =
  AuthenticatedProgramMeetingsRouteImport.update({
    id: '/program/meetings',
    path: '/program/meetings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProgramRoomsRoute =
  AuthenticatedProgramRoomsRouteImport.update({
    id: '/program/rooms',
    path: '/program/rooms',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProgramSessionsRoute =
  AuthenticatedProgramSessionsRouteImport.update({
    id: '/program/sessions',
    path: '/program/sessions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProgramSpeakersRoute =
  AuthenticatedProgramSpeakersRouteImport.update({
    id: '/program/speakers',
    path: '/program/speakers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsMembersRoute =
  AuthenticatedSettingsMembersRouteImport.update({
    id: '/settings/members',
    path: '/settings/members',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsOrganizationRoute =
  AuthenticatedSettingsOrganizationRouteImport.update({
    id: '/settings/organization',
    path: '/settings/organization',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsRolesRoute =
  AuthenticatedSettingsRolesRouteImport.update({
    id: '/settings/roles',
    path: '/settings/roles',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsThemeRoute =
  AuthenticatedSettingsThemeRouteImport.update({
    id: '/settings/theme',
    path: '/settings/theme',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketingCheckInRoute =
  AuthenticatedTicketingCheckInRouteImport.update({
    id: '/ticketing/check-in',
    path: '/ticketing/check-in',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketingDeskRoute =
  AuthenticatedTicketingDeskRouteImport.update({
    id: '/ticketing/desk',
    path: '/ticketing/desk',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketingRegistrationFormRoute =
  AuthenticatedTicketingRegistrationFormRouteImport.update({
    id: '/ticketing/registration-form',
    path: '/ticketing/registration-form',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketingRegistrationsRouteRoute =
  AuthenticatedTicketingRegistrationsRouteRouteImport.update({
    id: '/ticketing/registrations',
    path: '/ticketing/registrations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketingTicketTypesRoute =
  AuthenticatedTicketingTicketTypesRouteImport.update({
    id: '/ticketing/ticket-types',
    path: '/ticketing/ticket-types',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketingVouchersRoute =
  AuthenticatedTicketingVouchersRouteImport.update({
    id: '/ticketing/vouchers',
    path: '/ticketing/vouchers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedVotingIndexRoute =
  AuthenticatedVotingIndexRouteImport.update({
    id: '/voting/',
    path: '/voting/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingInvoicesIndexRoute =
  AuthenticatedBillingInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBillingInvoicesRouteRoute,
  } as any)
const AuthenticatedBillingInvoicesInvoiceIdRoute =
  AuthenticatedBillingInvoicesInvoiceIdRouteImport.update({
    id: '/$invoiceId',
    path: '/$invoiceId',
    getParentRoute: () => AuthenticatedBillingInvoicesRouteRoute,
  } as any)
const AuthenticatedBillingPaymentsIndexRoute =
  AuthenticatedBillingPaymentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBillingPaymentsRouteRoute,
  } as any)
const AuthenticatedBillingPaymentsPaymentIdRoute =
  AuthenticatedBillingPaymentsPaymentIdRouteImport.update({
    id: '/$paymentId',
    path: '/$paymentId',
    getParentRoute: () => AuthenticatedBillingPaymentsRouteRoute,
  } as any)
const AuthenticatedCmsContentIndexRoute =
  AuthenticatedCmsContentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCmsContentRouteRoute,
  } as any)
const AuthenticatedCmsContentIdRoute =
  AuthenticatedCmsContentIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedCmsContentRouteRoute,
  } as any)
const AuthenticatedExhibitionCompaniesIndexRoute =
  AuthenticatedExhibitionCompaniesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedExhibitionCompaniesRouteRoute,
  } as any)
const AuthenticatedExhibitionCompaniesCompanyIdRoute =
  AuthenticatedExhibitionCompaniesCompanyIdRouteImport.update({
    id: '/$companyId',
    path: '/$companyId',
    getParentRoute: () => AuthenticatedExhibitionCompaniesRouteRoute,
  } as any)
const AuthenticatedExhibitionExhibitorsIndexRoute =
  AuthenticatedExhibitionExhibitorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedExhibitionExhibitorsRouteRoute,
  } as any)
const AuthenticatedExhibitionExhibitorsApplicationIdRouteRoute =
  AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteImport.update({
    id: '/$applicationId',
    path: '/$applicationId',
    getParentRoute: () => AuthenticatedExhibitionExhibitorsRouteRoute,
  } as any)
const AuthenticatedExhibitionExhibitorsNewRoute =
  AuthenticatedExhibitionExhibitorsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedExhibitionExhibitorsRouteRoute,
  } as any)
const AuthenticatedExhibitionServiceOrdersIndexRoute =
  AuthenticatedExhibitionServiceOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedExhibitionServiceOrdersRouteRoute,
  } as any)
const AuthenticatedExhibitionServiceOrdersServiceOrderIdRoute =
  AuthenticatedExhibitionServiceOrdersServiceOrderIdRouteImport.update({
    id: '/$serviceOrderId',
    path: '/$serviceOrderId',
    getParentRoute: () => AuthenticatedExhibitionServiceOrdersRouteRoute,
  } as any)
const AuthenticatedExhibitionServiceOrdersNewRoute =
  AuthenticatedExhibitionServiceOrdersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedExhibitionServiceOrdersRouteRoute,
  } as any)
const AuthenticatedPlatformPlansIndexRoute =
  AuthenticatedPlatformPlansIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPlatformPlansRouteRoute,
  } as any)
const AuthenticatedPlatformPlansPlanIdRoute =
  AuthenticatedPlatformPlansPlanIdRouteImport.update({
    id: '/$planId',
    path: '/$planId',
    getParentRoute: () => AuthenticatedPlatformPlansRouteRoute,
  } as any)
const AuthenticatedPlatformSeriesIndexRoute =
  AuthenticatedPlatformSeriesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPlatformSeriesRouteRoute,
  } as any)
const AuthenticatedPlatformSeriesSeriesIdRoute =
  AuthenticatedPlatformSeriesSeriesIdRouteImport.update({
    id: '/$seriesId',
    path: '/$seriesId',
    getParentRoute: () => AuthenticatedPlatformSeriesRouteRoute,
  } as any)
const AuthenticatedPlatformTenantsIndexRoute =
  AuthenticatedPlatformTenantsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPlatformTenantsRouteRoute,
  } as any)
const AuthenticatedPlatformTenantsTenantIdRouteRoute =
  AuthenticatedPlatformTenantsTenantIdRouteRouteImport.update({
    id: '/$tenantId',
    path: '/$tenantId',
    getParentRoute: () => AuthenticatedPlatformTenantsRouteRoute,
  } as any)
const AuthenticatedPlatformUsersIndexRoute =
  AuthenticatedPlatformUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPlatformUsersRouteRoute,
  } as any)
const AuthenticatedPlatformUsersUserIdRoute =
  AuthenticatedPlatformUsersUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AuthenticatedPlatformUsersRouteRoute,
  } as any)
const AuthenticatedTicketingRegistrationsIndexRoute =
  AuthenticatedTicketingRegistrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTicketingRegistrationsRouteRoute,
  } as any)
const AuthenticatedTicketingRegistrationsRegistrationIdRouteRoute =
  AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteImport.update({
    id: '/$registrationId',
    path: '/$registrationId',
    getParentRoute: () => AuthenticatedTicketingRegistrationsRouteRoute,
  } as any)
const AuthenticatedTicketingRegistrationsImportRoute =
  AuthenticatedTicketingRegistrationsImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedTicketingRegistrationsRouteRoute,
  } as any)
const AuthenticatedExhibitionExhibitorsApplicationIdIndexRoute =
  AuthenticatedExhibitionExhibitorsApplicationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedExhibitionExhibitorsApplicationIdRouteRoute,
  } as any)
const AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRoute =
  AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRouteImport.update({
    id: '/$serviceOrderId_/edit',
    path: '/$serviceOrderId/edit',
    getParentRoute: () => AuthenticatedExhibitionServiceOrdersRouteRoute,
  } as any)
const AuthenticatedPlatformTenantsTenantIdIndexRoute =
  AuthenticatedPlatformTenantsTenantIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPlatformTenantsTenantIdRouteRoute,
  } as any)
const AuthenticatedPlatformTenantsTenantIdActivityRoute =
  AuthenticatedPlatformTenantsTenantIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedPlatformTenantsTenantIdRouteRoute,
  } as any)
const AuthenticatedPlatformTenantsTenantIdDomainsRoute =
  AuthenticatedPlatformTenantsTenantIdDomainsRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => AuthenticatedPlatformTenantsTenantIdRouteRoute,
  } as any)
const AuthenticatedPlatformTenantsTenantIdModulesRoute =
  AuthenticatedPlatformTenantsTenantIdModulesRouteImport.update({
    id: '/modules',
    path: '/modules',
    getParentRoute: () => AuthenticatedPlatformTenantsTenantIdRouteRoute,
  } as any)
const AuthenticatedPlatformTenantsTenantIdUsageRoute =
  AuthenticatedPlatformTenantsTenantIdUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedPlatformTenantsTenantIdRouteRoute,
  } as any)
const AuthenticatedTicketingRegistrationsRegistrationIdIndexRoute =
  AuthenticatedTicketingRegistrationsRegistrationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTicketingRegistrationsRegistrationIdRouteRoute,
  } as any)
const AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRoute =
  AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRouteImport.update(
    {
      id: '/add-participants',
      path: '/add-participants',
      getParentRoute: () =>
        AuthenticatedTicketingRegistrationsRegistrationIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/platform': typeof AuthenticatedPlatformRouteRouteWithChildren
  '/login': typeof publicLoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/billing/invoices': typeof AuthenticatedBillingInvoicesRouteRouteWithChildren
  '/billing/payments': typeof AuthenticatedBillingPaymentsRouteRouteWithChildren
  '/cms/content': typeof AuthenticatedCmsContentRouteRouteWithChildren
  '/exhibition/companies': typeof AuthenticatedExhibitionCompaniesRouteRouteWithChildren
  '/exhibition/exhibitors': typeof AuthenticatedExhibitionExhibitorsRouteRouteWithChildren
  '/exhibition/service-orders': typeof AuthenticatedExhibitionServiceOrdersRouteRouteWithChildren
  '/platform/plans': typeof AuthenticatedPlatformPlansRouteRouteWithChildren
  '/platform/series': typeof AuthenticatedPlatformSeriesRouteRouteWithChildren
  '/platform/tenants': typeof AuthenticatedPlatformTenantsRouteRouteWithChildren
  '/platform/users': typeof AuthenticatedPlatformUsersRouteRouteWithChildren
  '/ticketing/registrations': typeof AuthenticatedTicketingRegistrationsRouteRouteWithChildren
  '/billing/credit-notes': typeof AuthenticatedBillingCreditNotesRoute
  '/billing/exchange-rates': typeof AuthenticatedBillingExchangeRatesRoute
  '/billing/payment-methods': typeof AuthenticatedBillingPaymentMethodsRoute
  '/cms/media': typeof AuthenticatedCmsMediaRoute
  '/exhibition/floor': typeof AuthenticatedExhibitionFloorRoute
  '/exhibition/service-items': typeof AuthenticatedExhibitionServiceItemsRoute
  '/exhibition/service-terms': typeof AuthenticatedExhibitionServiceTermsRoute
  '/platform/activity': typeof AuthenticatedPlatformActivityRoute
  '/platform/payment-methods': typeof AuthenticatedPlatformPaymentMethodsRoute
  '/platform/usage': typeof AuthenticatedPlatformUsageRoute
  '/program/meetings': typeof AuthenticatedProgramMeetingsRoute
  '/program/rooms': typeof AuthenticatedProgramRoomsRoute
  '/program/sessions': typeof AuthenticatedProgramSessionsRoute
  '/program/speakers': typeof AuthenticatedProgramSpeakersRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/settings/roles': typeof AuthenticatedSettingsRolesRoute
  '/settings/theme': typeof AuthenticatedSettingsThemeRoute
  '/ticketing/check-in': typeof AuthenticatedTicketingCheckInRoute
  '/ticketing/desk': typeof AuthenticatedTicketingDeskRoute
  '/ticketing/registration-form': typeof AuthenticatedTicketingRegistrationFormRoute
  '/ticketing/ticket-types': typeof AuthenticatedTicketingTicketTypesRoute
  '/ticketing/vouchers': typeof AuthenticatedTicketingVouchersRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/platform/': typeof AuthenticatedPlatformIndexRoute
  '/voting/': typeof AuthenticatedVotingIndexRoute
  '/exhibition/exhibitors/$applicationId': typeof AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteWithChildren
  '/platform/tenants/$tenantId': typeof AuthenticatedPlatformTenantsTenantIdRouteRouteWithChildren
  '/ticketing/registrations/$registrationId': typeof AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteWithChildren
  '/billing/invoices/$invoiceId': typeof AuthenticatedBillingInvoicesInvoiceIdRoute
  '/billing/payments/$paymentId': typeof AuthenticatedBillingPaymentsPaymentIdRoute
  '/cms/content/$id': typeof AuthenticatedCmsContentIdRoute
  '/exhibition/companies/$companyId': typeof AuthenticatedExhibitionCompaniesCompanyIdRoute
  '/exhibition/exhibitors/new': typeof AuthenticatedExhibitionExhibitorsNewRoute
  '/exhibition/service-orders/$serviceOrderId': typeof AuthenticatedExhibitionServiceOrdersServiceOrderIdRoute
  '/exhibition/service-orders/new': typeof AuthenticatedExhibitionServiceOrdersNewRoute
  '/platform/plans/$planId': typeof AuthenticatedPlatformPlansPlanIdRoute
  '/platform/series/$seriesId': typeof AuthenticatedPlatformSeriesSeriesIdRoute
  '/platform/users/$userId': typeof AuthenticatedPlatformUsersUserIdRoute
  '/ticketing/registrations/import': typeof AuthenticatedTicketingRegistrationsImportRoute
  '/billing/invoices/': typeof AuthenticatedBillingInvoicesIndexRoute
  '/billing/payments/': typeof AuthenticatedBillingPaymentsIndexRoute
  '/cms/content/': typeof AuthenticatedCmsContentIndexRoute
  '/exhibition/companies/': typeof AuthenticatedExhibitionCompaniesIndexRoute
  '/exhibition/exhibitors/': typeof AuthenticatedExhibitionExhibitorsIndexRoute
  '/exhibition/service-orders/': typeof AuthenticatedExhibitionServiceOrdersIndexRoute
  '/platform/plans/': typeof AuthenticatedPlatformPlansIndexRoute
  '/platform/series/': typeof AuthenticatedPlatformSeriesIndexRoute
  '/platform/tenants/': typeof AuthenticatedPlatformTenantsIndexRoute
  '/platform/users/': typeof AuthenticatedPlatformUsersIndexRoute
  '/ticketing/registrations/': typeof AuthenticatedTicketingRegistrationsIndexRoute
  '/exhibition/service-orders/$serviceOrderId/edit': typeof AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRoute
  '/platform/tenants/$tenantId/activity': typeof AuthenticatedPlatformTenantsTenantIdActivityRoute
  '/platform/tenants/$tenantId/domains': typeof AuthenticatedPlatformTenantsTenantIdDomainsRoute
  '/platform/tenants/$tenantId/modules': typeof AuthenticatedPlatformTenantsTenantIdModulesRoute
  '/platform/tenants/$tenantId/usage': typeof AuthenticatedPlatformTenantsTenantIdUsageRoute
  '/ticketing/registrations/$registrationId/add-participants': typeof AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRoute
  '/exhibition/exhibitors/$applicationId/': typeof AuthenticatedExhibitionExhibitorsApplicationIdIndexRoute
  '/platform/tenants/$tenantId/': typeof AuthenticatedPlatformTenantsTenantIdIndexRoute
  '/ticketing/registrations/$registrationId/': typeof AuthenticatedTicketingRegistrationsRegistrationIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof publicLoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/': typeof AuthenticatedIndexRoute
  '/billing/credit-notes': typeof AuthenticatedBillingCreditNotesRoute
  '/billing/exchange-rates': typeof AuthenticatedBillingExchangeRatesRoute
  '/billing/payment-methods': typeof AuthenticatedBillingPaymentMethodsRoute
  '/cms/media': typeof AuthenticatedCmsMediaRoute
  '/exhibition/floor': typeof AuthenticatedExhibitionFloorRoute
  '/exhibition/service-items': typeof AuthenticatedExhibitionServiceItemsRoute
  '/exhibition/service-terms': typeof AuthenticatedExhibitionServiceTermsRoute
  '/platform/activity': typeof AuthenticatedPlatformActivityRoute
  '/platform/payment-methods': typeof AuthenticatedPlatformPaymentMethodsRoute
  '/platform/usage': typeof AuthenticatedPlatformUsageRoute
  '/program/meetings': typeof AuthenticatedProgramMeetingsRoute
  '/program/rooms': typeof AuthenticatedProgramRoomsRoute
  '/program/sessions': typeof AuthenticatedProgramSessionsRoute
  '/program/speakers': typeof AuthenticatedProgramSpeakersRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/settings/roles': typeof AuthenticatedSettingsRolesRoute
  '/settings/theme': typeof AuthenticatedSettingsThemeRoute
  '/ticketing/check-in': typeof AuthenticatedTicketingCheckInRoute
  '/ticketing/desk': typeof AuthenticatedTicketingDeskRoute
  '/ticketing/registration-form': typeof AuthenticatedTicketingRegistrationFormRoute
  '/ticketing/ticket-types': typeof AuthenticatedTicketingTicketTypesRoute
  '/ticketing/vouchers': typeof AuthenticatedTicketingVouchersRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/platform': typeof AuthenticatedPlatformIndexRoute
  '/voting': typeof AuthenticatedVotingIndexRoute
  '/billing/invoices/$invoiceId': typeof AuthenticatedBillingInvoicesInvoiceIdRoute
  '/billing/payments/$paymentId': typeof AuthenticatedBillingPaymentsPaymentIdRoute
  '/cms/content/$id': typeof AuthenticatedCmsContentIdRoute
  '/exhibition/companies/$companyId': typeof AuthenticatedExhibitionCompaniesCompanyIdRoute
  '/exhibition/exhibitors/new': typeof AuthenticatedExhibitionExhibitorsNewRoute
  '/exhibition/service-orders/$serviceOrderId': typeof AuthenticatedExhibitionServiceOrdersServiceOrderIdRoute
  '/exhibition/service-orders/new': typeof AuthenticatedExhibitionServiceOrdersNewRoute
  '/platform/plans/$planId': typeof AuthenticatedPlatformPlansPlanIdRoute
  '/platform/series/$seriesId': typeof AuthenticatedPlatformSeriesSeriesIdRoute
  '/platform/users/$userId': typeof AuthenticatedPlatformUsersUserIdRoute
  '/ticketing/registrations/import': typeof AuthenticatedTicketingRegistrationsImportRoute
  '/billing/invoices': typeof AuthenticatedBillingInvoicesIndexRoute
  '/billing/payments': typeof AuthenticatedBillingPaymentsIndexRoute
  '/cms/content': typeof AuthenticatedCmsContentIndexRoute
  '/exhibition/companies': typeof AuthenticatedExhibitionCompaniesIndexRoute
  '/exhibition/exhibitors': typeof AuthenticatedExhibitionExhibitorsIndexRoute
  '/exhibition/service-orders': typeof AuthenticatedExhibitionServiceOrdersIndexRoute
  '/platform/plans': typeof AuthenticatedPlatformPlansIndexRoute
  '/platform/series': typeof AuthenticatedPlatformSeriesIndexRoute
  '/platform/tenants': typeof AuthenticatedPlatformTenantsIndexRoute
  '/platform/users': typeof AuthenticatedPlatformUsersIndexRoute
  '/ticketing/registrations': typeof AuthenticatedTicketingRegistrationsIndexRoute
  '/exhibition/service-orders/$serviceOrderId/edit': typeof AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRoute
  '/platform/tenants/$tenantId/activity': typeof AuthenticatedPlatformTenantsTenantIdActivityRoute
  '/platform/tenants/$tenantId/domains': typeof AuthenticatedPlatformTenantsTenantIdDomainsRoute
  '/platform/tenants/$tenantId/modules': typeof AuthenticatedPlatformTenantsTenantIdModulesRoute
  '/platform/tenants/$tenantId/usage': typeof AuthenticatedPlatformTenantsTenantIdUsageRoute
  '/ticketing/registrations/$registrationId/add-participants': typeof AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRoute
  '/exhibition/exhibitors/$applicationId': typeof AuthenticatedExhibitionExhibitorsApplicationIdIndexRoute
  '/platform/tenants/$tenantId': typeof AuthenticatedPlatformTenantsTenantIdIndexRoute
  '/ticketing/registrations/$registrationId': typeof AuthenticatedTicketingRegistrationsRegistrationIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/platform': typeof AuthenticatedPlatformRouteRouteWithChildren
  '/(public)/login': typeof publicLoginRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/billing/invoices': typeof AuthenticatedBillingInvoicesRouteRouteWithChildren
  '/_authenticated/billing/payments': typeof AuthenticatedBillingPaymentsRouteRouteWithChildren
  '/_authenticated/cms/content': typeof AuthenticatedCmsContentRouteRouteWithChildren
  '/_authenticated/exhibition/companies': typeof AuthenticatedExhibitionCompaniesRouteRouteWithChildren
  '/_authenticated/exhibition/exhibitors': typeof AuthenticatedExhibitionExhibitorsRouteRouteWithChildren
  '/_authenticated/exhibition/service-orders': typeof AuthenticatedExhibitionServiceOrdersRouteRouteWithChildren
  '/_authenticated/platform/plans': typeof AuthenticatedPlatformPlansRouteRouteWithChildren
  '/_authenticated/platform/series': typeof AuthenticatedPlatformSeriesRouteRouteWithChildren
  '/_authenticated/platform/tenants': typeof AuthenticatedPlatformTenantsRouteRouteWithChildren
  '/_authenticated/platform/users': typeof AuthenticatedPlatformUsersRouteRouteWithChildren
  '/_authenticated/ticketing/registrations': typeof AuthenticatedTicketingRegistrationsRouteRouteWithChildren
  '/_authenticated/billing/credit-notes': typeof AuthenticatedBillingCreditNotesRoute
  '/_authenticated/billing/exchange-rates': typeof AuthenticatedBillingExchangeRatesRoute
  '/_authenticated/billing/payment-methods': typeof AuthenticatedBillingPaymentMethodsRoute
  '/_authenticated/cms/media': typeof AuthenticatedCmsMediaRoute
  '/_authenticated/exhibition/floor': typeof AuthenticatedExhibitionFloorRoute
  '/_authenticated/exhibition/service-items': typeof AuthenticatedExhibitionServiceItemsRoute
  '/_authenticated/exhibition/service-terms': typeof AuthenticatedExhibitionServiceTermsRoute
  '/_authenticated/platform/activity': typeof AuthenticatedPlatformActivityRoute
  '/_authenticated/platform/payment-methods': typeof AuthenticatedPlatformPaymentMethodsRoute
  '/_authenticated/platform/usage': typeof AuthenticatedPlatformUsageRoute
  '/_authenticated/program/meetings': typeof AuthenticatedProgramMeetingsRoute
  '/_authenticated/program/rooms': typeof AuthenticatedProgramRoomsRoute
  '/_authenticated/program/sessions': typeof AuthenticatedProgramSessionsRoute
  '/_authenticated/program/speakers': typeof AuthenticatedProgramSpeakersRoute
  '/_authenticated/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/_authenticated/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/_authenticated/settings/roles': typeof AuthenticatedSettingsRolesRoute
  '/_authenticated/settings/theme': typeof AuthenticatedSettingsThemeRoute
  '/_authenticated/ticketing/check-in': typeof AuthenticatedTicketingCheckInRoute
  '/_authenticated/ticketing/desk': typeof AuthenticatedTicketingDeskRoute
  '/_authenticated/ticketing/registration-form': typeof AuthenticatedTicketingRegistrationFormRoute
  '/_authenticated/ticketing/ticket-types': typeof AuthenticatedTicketingTicketTypesRoute
  '/_authenticated/ticketing/vouchers': typeof AuthenticatedTicketingVouchersRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/platform/': typeof AuthenticatedPlatformIndexRoute
  '/_authenticated/voting/': typeof AuthenticatedVotingIndexRoute
  '/_authenticated/exhibition/exhibitors/$applicationId': typeof AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteWithChildren
  '/_authenticated/platform/tenants/$tenantId': typeof AuthenticatedPlatformTenantsTenantIdRouteRouteWithChildren
  '/_authenticated/ticketing/registrations/$registrationId': typeof AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteWithChildren
  '/_authenticated/billing/invoices/$invoiceId': typeof AuthenticatedBillingInvoicesInvoiceIdRoute
  '/_authenticated/billing/payments/$paymentId': typeof AuthenticatedBillingPaymentsPaymentIdRoute
  '/_authenticated/cms/content/$id': typeof AuthenticatedCmsContentIdRoute
  '/_authenticated/exhibition/companies/$companyId': typeof AuthenticatedExhibitionCompaniesCompanyIdRoute
  '/_authenticated/exhibition/exhibitors/new': typeof AuthenticatedExhibitionExhibitorsNewRoute
  '/_authenticated/exhibition/service-orders/$serviceOrderId': typeof AuthenticatedExhibitionServiceOrdersServiceOrderIdRoute
  '/_authenticated/exhibition/service-orders/new': typeof AuthenticatedExhibitionServiceOrdersNewRoute
  '/_authenticated/platform/plans/$planId': typeof AuthenticatedPlatformPlansPlanIdRoute
  '/_authenticated/platform/series/$seriesId': typeof AuthenticatedPlatformSeriesSeriesIdRoute
  '/_authenticated/platform/users/$userId': typeof AuthenticatedPlatformUsersUserIdRoute
  '/_authenticated/ticketing/registrations/import': typeof AuthenticatedTicketingRegistrationsImportRoute
  '/_authenticated/billing/invoices/': typeof AuthenticatedBillingInvoicesIndexRoute
  '/_authenticated/billing/payments/': typeof AuthenticatedBillingPaymentsIndexRoute
  '/_authenticated/cms/content/': typeof AuthenticatedCmsContentIndexRoute
  '/_authenticated/exhibition/companies/': typeof AuthenticatedExhibitionCompaniesIndexRoute
  '/_authenticated/exhibition/exhibitors/': typeof AuthenticatedExhibitionExhibitorsIndexRoute
  '/_authenticated/exhibition/service-orders/': typeof AuthenticatedExhibitionServiceOrdersIndexRoute
  '/_authenticated/platform/plans/': typeof AuthenticatedPlatformPlansIndexRoute
  '/_authenticated/platform/series/': typeof AuthenticatedPlatformSeriesIndexRoute
  '/_authenticated/platform/tenants/': typeof AuthenticatedPlatformTenantsIndexRoute
  '/_authenticated/platform/users/': typeof AuthenticatedPlatformUsersIndexRoute
  '/_authenticated/ticketing/registrations/': typeof AuthenticatedTicketingRegistrationsIndexRoute
  '/_authenticated/exhibition/service-orders/$serviceOrderId_/edit': typeof AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRoute
  '/_authenticated/platform/tenants/$tenantId/activity': typeof AuthenticatedPlatformTenantsTenantIdActivityRoute
  '/_authenticated/platform/tenants/$tenantId/domains': typeof AuthenticatedPlatformTenantsTenantIdDomainsRoute
  '/_authenticated/platform/tenants/$tenantId/modules': typeof AuthenticatedPlatformTenantsTenantIdModulesRoute
  '/_authenticated/platform/tenants/$tenantId/usage': typeof AuthenticatedPlatformTenantsTenantIdUsageRoute
  '/_authenticated/ticketing/registrations/$registrationId/add-participants': typeof AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRoute
  '/_authenticated/exhibition/exhibitors/$applicationId/': typeof AuthenticatedExhibitionExhibitorsApplicationIdIndexRoute
  '/_authenticated/platform/tenants/$tenantId/': typeof AuthenticatedPlatformTenantsTenantIdIndexRoute
  '/_authenticated/ticketing/registrations/$registrationId/': typeof AuthenticatedTicketingRegistrationsRegistrationIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/platform'
    | '/login'
    | '/account'
    | '/billing/invoices'
    | '/billing/payments'
    | '/cms/content'
    | '/exhibition/companies'
    | '/exhibition/exhibitors'
    | '/exhibition/service-orders'
    | '/platform/plans'
    | '/platform/series'
    | '/platform/tenants'
    | '/platform/users'
    | '/ticketing/registrations'
    | '/billing/credit-notes'
    | '/billing/exchange-rates'
    | '/billing/payment-methods'
    | '/cms/media'
    | '/exhibition/floor'
    | '/exhibition/service-items'
    | '/exhibition/service-terms'
    | '/platform/activity'
    | '/platform/payment-methods'
    | '/platform/usage'
    | '/program/meetings'
    | '/program/rooms'
    | '/program/sessions'
    | '/program/speakers'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/roles'
    | '/settings/theme'
    | '/ticketing/check-in'
    | '/ticketing/desk'
    | '/ticketing/registration-form'
    | '/ticketing/ticket-types'
    | '/ticketing/vouchers'
    | '/dashboard/'
    | '/platform/'
    | '/voting/'
    | '/exhibition/exhibitors/$applicationId'
    | '/platform/tenants/$tenantId'
    | '/ticketing/registrations/$registrationId'
    | '/billing/invoices/$invoiceId'
    | '/billing/payments/$paymentId'
    | '/cms/content/$id'
    | '/exhibition/companies/$companyId'
    | '/exhibition/exhibitors/new'
    | '/exhibition/service-orders/$serviceOrderId'
    | '/exhibition/service-orders/new'
    | '/platform/plans/$planId'
    | '/platform/series/$seriesId'
    | '/platform/users/$userId'
    | '/ticketing/registrations/import'
    | '/billing/invoices/'
    | '/billing/payments/'
    | '/cms/content/'
    | '/exhibition/companies/'
    | '/exhibition/exhibitors/'
    | '/exhibition/service-orders/'
    | '/platform/plans/'
    | '/platform/series/'
    | '/platform/tenants/'
    | '/platform/users/'
    | '/ticketing/registrations/'
    | '/exhibition/service-orders/$serviceOrderId/edit'
    | '/platform/tenants/$tenantId/activity'
    | '/platform/tenants/$tenantId/domains'
    | '/platform/tenants/$tenantId/modules'
    | '/platform/tenants/$tenantId/usage'
    | '/ticketing/registrations/$registrationId/add-participants'
    | '/exhibition/exhibitors/$applicationId/'
    | '/platform/tenants/$tenantId/'
    | '/ticketing/registrations/$registrationId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/account'
    | '/'
    | '/billing/credit-notes'
    | '/billing/exchange-rates'
    | '/billing/payment-methods'
    | '/cms/media'
    | '/exhibition/floor'
    | '/exhibition/service-items'
    | '/exhibition/service-terms'
    | '/platform/activity'
    | '/platform/payment-methods'
    | '/platform/usage'
    | '/program/meetings'
    | '/program/rooms'
    | '/program/sessions'
    | '/program/speakers'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/roles'
    | '/settings/theme'
    | '/ticketing/check-in'
    | '/ticketing/desk'
    | '/ticketing/registration-form'
    | '/ticketing/ticket-types'
    | '/ticketing/vouchers'
    | '/dashboard'
    | '/platform'
    | '/voting'
    | '/billing/invoices/$invoiceId'
    | '/billing/payments/$paymentId'
    | '/cms/content/$id'
    | '/exhibition/companies/$companyId'
    | '/exhibition/exhibitors/new'
    | '/exhibition/service-orders/$serviceOrderId'
    | '/exhibition/service-orders/new'
    | '/platform/plans/$planId'
    | '/platform/series/$seriesId'
    | '/platform/users/$userId'
    | '/ticketing/registrations/import'
    | '/billing/invoices'
    | '/billing/payments'
    | '/cms/content'
    | '/exhibition/companies'
    | '/exhibition/exhibitors'
    | '/exhibition/service-orders'
    | '/platform/plans'
    | '/platform/series'
    | '/platform/tenants'
    | '/platform/users'
    | '/ticketing/registrations'
    | '/exhibition/service-orders/$serviceOrderId/edit'
    | '/platform/tenants/$tenantId/activity'
    | '/platform/tenants/$tenantId/domains'
    | '/platform/tenants/$tenantId/modules'
    | '/platform/tenants/$tenantId/usage'
    | '/ticketing/registrations/$registrationId/add-participants'
    | '/exhibition/exhibitors/$applicationId'
    | '/platform/tenants/$tenantId'
    | '/ticketing/registrations/$registrationId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/platform'
    | '/(public)/login'
    | '/_authenticated/account'
    | '/_authenticated/'
    | '/_authenticated/billing/invoices'
    | '/_authenticated/billing/payments'
    | '/_authenticated/cms/content'
    | '/_authenticated/exhibition/companies'
    | '/_authenticated/exhibition/exhibitors'
    | '/_authenticated/exhibition/service-orders'
    | '/_authenticated/platform/plans'
    | '/_authenticated/platform/series'
    | '/_authenticated/platform/tenants'
    | '/_authenticated/platform/users'
    | '/_authenticated/ticketing/registrations'
    | '/_authenticated/billing/credit-notes'
    | '/_authenticated/billing/exchange-rates'
    | '/_authenticated/billing/payment-methods'
    | '/_authenticated/cms/media'
    | '/_authenticated/exhibition/floor'
    | '/_authenticated/exhibition/service-items'
    | '/_authenticated/exhibition/service-terms'
    | '/_authenticated/platform/activity'
    | '/_authenticated/platform/payment-methods'
    | '/_authenticated/platform/usage'
    | '/_authenticated/program/meetings'
    | '/_authenticated/program/rooms'
    | '/_authenticated/program/sessions'
    | '/_authenticated/program/speakers'
    | '/_authenticated/settings/members'
    | '/_authenticated/settings/organization'
    | '/_authenticated/settings/roles'
    | '/_authenticated/settings/theme'
    | '/_authenticated/ticketing/check-in'
    | '/_authenticated/ticketing/desk'
    | '/_authenticated/ticketing/registration-form'
    | '/_authenticated/ticketing/ticket-types'
    | '/_authenticated/ticketing/vouchers'
    | '/_authenticated/dashboard/'
    | '/_authenticated/platform/'
    | '/_authenticated/voting/'
    | '/_authenticated/exhibition/exhibitors/$applicationId'
    | '/_authenticated/platform/tenants/$tenantId'
    | '/_authenticated/ticketing/registrations/$registrationId'
    | '/_authenticated/billing/invoices/$invoiceId'
    | '/_authenticated/billing/payments/$paymentId'
    | '/_authenticated/cms/content/$id'
    | '/_authenticated/exhibition/companies/$companyId'
    | '/_authenticated/exhibition/exhibitors/new'
    | '/_authenticated/exhibition/service-orders/$serviceOrderId'
    | '/_authenticated/exhibition/service-orders/new'
    | '/_authenticated/platform/plans/$planId'
    | '/_authenticated/platform/series/$seriesId'
    | '/_authenticated/platform/users/$userId'
    | '/_authenticated/ticketing/registrations/import'
    | '/_authenticated/billing/invoices/'
    | '/_authenticated/billing/payments/'
    | '/_authenticated/cms/content/'
    | '/_authenticated/exhibition/companies/'
    | '/_authenticated/exhibition/exhibitors/'
    | '/_authenticated/exhibition/service-orders/'
    | '/_authenticated/platform/plans/'
    | '/_authenticated/platform/series/'
    | '/_authenticated/platform/tenants/'
    | '/_authenticated/platform/users/'
    | '/_authenticated/ticketing/registrations/'
    | '/_authenticated/exhibition/service-orders/$serviceOrderId_/edit'
    | '/_authenticated/platform/tenants/$tenantId/activity'
    | '/_authenticated/platform/tenants/$tenantId/domains'
    | '/_authenticated/platform/tenants/$tenantId/modules'
    | '/_authenticated/platform/tenants/$tenantId/usage'
    | '/_authenticated/ticketing/registrations/$registrationId/add-participants'
    | '/_authenticated/exhibition/exhibitors/$applicationId/'
    | '/_authenticated/platform/tenants/$tenantId/'
    | '/_authenticated/ticketing/registrations/$registrationId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  publicLoginRoute: typeof publicLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/login': {
      id: '/(public)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof publicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/platform': {
      id: '/_authenticated/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof AuthenticatedPlatformRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/credit-notes': {
      id: '/_authenticated/billing/credit-notes'
      path: '/billing/credit-notes'
      fullPath: '/billing/credit-notes'
      preLoaderRoute: typeof AuthenticatedBillingCreditNotesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/exchange-rates': {
      id: '/_authenticated/billing/exchange-rates'
      path: '/billing/exchange-rates'
      fullPath: '/billing/exchange-rates'
      preLoaderRoute: typeof AuthenticatedBillingExchangeRatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/invoices': {
      id: '/_authenticated/billing/invoices'
      path: '/billing/invoices'
      fullPath: '/billing/invoices'
      preLoaderRoute: typeof AuthenticatedBillingInvoicesRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/payment-methods': {
      id: '/_authenticated/billing/payment-methods'
      path: '/billing/payment-methods'
      fullPath: '/billing/payment-methods'
      preLoaderRoute: typeof AuthenticatedBillingPaymentMethodsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/payments': {
      id: '/_authenticated/billing/payments'
      path: '/billing/payments'
      fullPath: '/billing/payments'
      preLoaderRoute: typeof AuthenticatedBillingPaymentsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cms/content': {
      id: '/_authenticated/cms/content'
      path: '/cms/content'
      fullPath: '/cms/content'
      preLoaderRoute: typeof AuthenticatedCmsContentRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cms/media': {
      id: '/_authenticated/cms/media'
      path: '/cms/media'
      fullPath: '/cms/media'
      preLoaderRoute: typeof AuthenticatedCmsMediaRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/exhibition/companies': {
      id: '/_authenticated/exhibition/companies'
      path: '/exhibition/companies'
      fullPath: '/exhibition/companies'
      preLoaderRoute: typeof AuthenticatedExhibitionCompaniesRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/exhibition/exhibitors': {
      id: '/_authenticated/exhibition/exhibitors'
      path: '/exhibition/exhibitors'
      fullPath: '/exhibition/exhibitors'
      preLoaderRoute: typeof AuthenticatedExhibitionExhibitorsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/exhibition/floor': {
      id: '/_authenticated/exhibition/floor'
      path: '/exhibition/floor'
      fullPath: '/exhibition/floor'
      preLoaderRoute: typeof AuthenticatedExhibitionFloorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/exhibition/service-items': {
      id: '/_authenticated/exhibition/service-items'
      path: '/exhibition/service-items'
      fullPath: '/exhibition/service-items'
      preLoaderRoute: typeof AuthenticatedExhibitionServiceItemsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/exhibition/service-orders': {
      id: '/_authenticated/exhibition/service-orders'
      path: '/exhibition/service-orders'
      fullPath: '/exhibition/service-orders'
      preLoaderRoute: typeof AuthenticatedExhibitionServiceOrdersRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/exhibition/service-terms': {
      id: '/_authenticated/exhibition/service-terms'
      path: '/exhibition/service-terms'
      fullPath: '/exhibition/service-terms'
      preLoaderRoute: typeof AuthenticatedExhibitionServiceTermsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/platform/': {
      id: '/_authenticated/platform/'
      path: '/'
      fullPath: '/platform/'
      preLoaderRoute: typeof AuthenticatedPlatformIndexRouteImport
      parentRoute: typeof AuthenticatedPlatformRouteRoute
    }
    '/_authenticated/platform/activity': {
      id: '/_authenticated/platform/activity'
      path: '/activity'
      fullPath: '/platform/activity'
      preLoaderRoute: typeof AuthenticatedPlatformActivityRouteImport
      parentRoute: typeof AuthenticatedPlatformRouteRoute
    }
    '/_authenticated/platform/payment-methods': {
      id: '/_authenticated/platform/payment-methods'
      path: '/payment-methods'
      fullPath: '/platform/payment-methods'
      preLoaderRoute: typeof AuthenticatedPlatformPaymentMethodsRouteImport
      parentRoute: typeof AuthenticatedPlatformRouteRoute
    }
    '/_authenticated/platform/plans': {
      id: '/_authenticated/platform/plans'
      path: '/plans'
      fullPath: '/platform/plans'
      preLoaderRoute: typeof AuthenticatedPlatformPlansRouteRouteImport
      parentRoute: typeof AuthenticatedPlatformRouteRoute
    }
    '/_authenticated/platform/series': {
      id: '/_authenticated/platform/series'
      path: '/series'
      fullPath: '/platform/series'
      preLoaderRoute: typeof AuthenticatedPlatformSeriesRouteRouteImport
      parentRoute: typeof AuthenticatedPlatformRouteRoute
    }
    '/_authenticated/platform/tenants': {
      id: '/_authenticated/platform/tenants'
      path: '/tenants'
      fullPath: '/platform/tenants'
      preLoaderRoute: typeof AuthenticatedPlatformTenantsRouteRouteImport
      parentRoute: typeof AuthenticatedPlatformRouteRoute
    }
    '/_authenticated/platform/usage': {
      id: '/_authenticated/platform/usage'
      path: '/usage'
      fullPath: '/platform/usage'
      preLoaderRoute: typeof AuthenticatedPlatformUsageRouteImport
      parentRoute: typeof AuthenticatedPlatformRouteRoute
    }
    '/_authenticated/platform/users': {
      id: '/_authenticated/platform/users'
      path: '/users'
      fullPath: '/platform/users'
      preLoaderRoute: typeof AuthenticatedPlatformUsersRouteRouteImport
      parentRoute: typeof AuthenticatedPlatformRouteRoute
    }
    '/_authenticated/program/meetings': {
      id: '/_authenticated/program/meetings'
      path: '/program/meetings'
      fullPath: '/program/meetings'
      preLoaderRoute: typeof AuthenticatedProgramMeetingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/program/rooms': {
      id: '/_authenticated/program/rooms'
      path: '/program/rooms'
      fullPath: '/program/rooms'
      preLoaderRoute: typeof AuthenticatedProgramRoomsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/program/sessions': {
      id: '/_authenticated/program/sessions'
      path: '/program/sessions'
      fullPath: '/program/sessions'
      preLoaderRoute: typeof AuthenticatedProgramSessionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/program/speakers': {
      id: '/_authenticated/program/speakers'
      path: '/program/speakers'
      fullPath: '/program/speakers'
      preLoaderRoute: typeof AuthenticatedProgramSpeakersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/members': {
      id: '/_authenticated/settings/members'
      path: '/settings/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthenticatedSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/organization': {
      id: '/_authenticated/settings/organization'
      path: '/settings/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/roles': {
      id: '/_authenticated/settings/roles'
      path: '/settings/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthenticatedSettingsRolesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/theme': {
      id: '/_authenticated/settings/theme'
      path: '/settings/theme'
      fullPath: '/settings/theme'
      preLoaderRoute: typeof AuthenticatedSettingsThemeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticketing/check-in': {
      id: '/_authenticated/ticketing/check-in'
      path: '/ticketing/check-in'
      fullPath: '/ticketing/check-in'
      preLoaderRoute: typeof AuthenticatedTicketingCheckInRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticketing/desk': {
      id: '/_authenticated/ticketing/desk'
      path: '/ticketing/desk'
      fullPath: '/ticketing/desk'
      preLoaderRoute: typeof AuthenticatedTicketingDeskRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticketing/registration-form': {
      id: '/_authenticated/ticketing/registration-form'
      path: '/ticketing/registration-form'
      fullPath: '/ticketing/registration-form'
      preLoaderRoute: typeof AuthenticatedTicketingRegistrationFormRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticketing/registrations': {
      id: '/_authenticated/ticketing/registrations'
      path: '/ticketing/registrations'
      fullPath: '/ticketing/registrations'
      preLoaderRoute: typeof AuthenticatedTicketingRegistrationsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticketing/ticket-types': {
      id: '/_authenticated/ticketing/ticket-types'
      path: '/ticketing/ticket-types'
      fullPath: '/ticketing/ticket-types'
      preLoaderRoute: typeof AuthenticatedTicketingTicketTypesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticketing/vouchers': {
      id: '/_authenticated/ticketing/vouchers'
      path: '/ticketing/vouchers'
      fullPath: '/ticketing/vouchers'
      preLoaderRoute: typeof AuthenticatedTicketingVouchersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/voting/': {
      id: '/_authenticated/voting/'
      path: '/voting'
      fullPath: '/voting/'
      preLoaderRoute: typeof AuthenticatedVotingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/invoices/': {
      id: '/_authenticated/billing/invoices/'
      path: '/'
      fullPath: '/billing/invoices/'
      preLoaderRoute: typeof AuthenticatedBillingInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedBillingInvoicesRouteRoute
    }
    '/_authenticated/billing/invoices/$invoiceId': {
      id: '/_authenticated/billing/invoices/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/billing/invoices/$invoiceId'
      preLoaderRoute: typeof AuthenticatedBillingInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthenticatedBillingInvoicesRouteRoute
    }
    '/_authenticated/billing/payments/': {
      id: '/_authenticated/billing/payments/'
      path: '/'
      fullPath: '/billing/payments/'
      preLoaderRoute: typeof AuthenticatedBillingPaymentsIndexRouteImport
      parentRoute: typeof AuthenticatedBillingPaymentsRouteRoute
    }
    '/_authenticated/billing/payments/$paymentId': {
      id: '/_authenticated/billing/payments/$paymentId'
      path: '/$paymentId'
      fullPath: '/billing/payments/$paymentId'
      preLoaderRoute: typeof AuthenticatedBillingPaymentsPaymentIdRouteImport
      parentRoute: typeof AuthenticatedBillingPaymentsRouteRoute
    }
    '/_authenticated/cms/content/': {
      id: '/_authenticated/cms/content/'
      path: '/'
      fullPath: '/cms/content/'
      preLoaderRoute: typeof AuthenticatedCmsContentIndexRouteImport
      parentRoute: typeof AuthenticatedCmsContentRouteRoute
    }
    '/_authenticated/cms/content/$id': {
      id: '/_authenticated/cms/content/$id'
      path: '/$id'
      fullPath: '/cms/content/$id'
      preLoaderRoute: typeof AuthenticatedCmsContentIdRouteImport
      parentRoute: typeof AuthenticatedCmsContentRouteRoute
    }
    '/_authenticated/exhibition/companies/': {
      id: '/_authenticated/exhibition/companies/'
      path: '/'
      fullPath: '/exhibition/companies/'
      preLoaderRoute: typeof AuthenticatedExhibitionCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedExhibitionCompaniesRouteRoute
    }
    '/_authenticated/exhibition/companies/$companyId': {
      id: '/_authenticated/exhibition/companies/$companyId'
      path: '/$companyId'
      fullPath: '/exhibition/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedExhibitionCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedExhibitionCompaniesRouteRoute
    }
    '/_authenticated/exhibition/exhibitors/': {
      id: '/_authenticated/exhibition/exhibitors/'
      path: '/'
      fullPath: '/exhibition/exhibitors/'
      preLoaderRoute: typeof AuthenticatedExhibitionExhibitorsIndexRouteImport
      parentRoute: typeof AuthenticatedExhibitionExhibitorsRouteRoute
    }
    '/_authenticated/exhibition/exhibitors/$applicationId': {
      id: '/_authenticated/exhibition/exhibitors/$applicationId'
      path: '/$applicationId'
      fullPath: '/exhibition/exhibitors/$applicationId'
      preLoaderRoute: typeof AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteImport
      parentRoute: typeof AuthenticatedExhibitionExhibitorsRouteRoute
    }
    '/_authenticated/exhibition/exhibitors/new': {
      id: '/_authenticated/exhibition/exhibitors/new'
      path: '/new'
      fullPath: '/exhibition/exhibitors/new'
      preLoaderRoute: typeof AuthenticatedExhibitionExhibitorsNewRouteImport
      parentRoute: typeof AuthenticatedExhibitionExhibitorsRouteRoute
    }
    '/_authenticated/exhibition/service-orders/': {
      id: '/_authenticated/exhibition/service-orders/'
      path: '/'
      fullPath: '/exhibition/service-orders/'
      preLoaderRoute: typeof AuthenticatedExhibitionServiceOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedExhibitionServiceOrdersRouteRoute
    }
    '/_authenticated/exhibition/service-orders/$serviceOrderId': {
      id: '/_authenticated/exhibition/service-orders/$serviceOrderId'
      path: '/$serviceOrderId'
      fullPath: '/exhibition/service-orders/$serviceOrderId'
      preLoaderRoute: typeof AuthenticatedExhibitionServiceOrdersServiceOrderIdRouteImport
      parentRoute: typeof AuthenticatedExhibitionServiceOrdersRouteRoute
    }
    '/_authenticated/exhibition/service-orders/new': {
      id: '/_authenticated/exhibition/service-orders/new'
      path: '/new'
      fullPath: '/exhibition/service-orders/new'
      preLoaderRoute: typeof AuthenticatedExhibitionServiceOrdersNewRouteImport
      parentRoute: typeof AuthenticatedExhibitionServiceOrdersRouteRoute
    }
    '/_authenticated/platform/plans/': {
      id: '/_authenticated/platform/plans/'
      path: '/'
      fullPath: '/platform/plans/'
      preLoaderRoute: typeof AuthenticatedPlatformPlansIndexRouteImport
      parentRoute: typeof AuthenticatedPlatformPlansRouteRoute
    }
    '/_authenticated/platform/plans/$planId': {
      id: '/_authenticated/platform/plans/$planId'
      path: '/$planId'
      fullPath: '/platform/plans/$planId'
      preLoaderRoute: typeof AuthenticatedPlatformPlansPlanIdRouteImport
      parentRoute: typeof AuthenticatedPlatformPlansRouteRoute
    }
    '/_authenticated/platform/series/': {
      id: '/_authenticated/platform/series/'
      path: '/'
      fullPath: '/platform/series/'
      preLoaderRoute: typeof AuthenticatedPlatformSeriesIndexRouteImport
      parentRoute: typeof AuthenticatedPlatformSeriesRouteRoute
    }
    '/_authenticated/platform/series/$seriesId': {
      id: '/_authenticated/platform/series/$seriesId'
      path: '/$seriesId'
      fullPath: '/platform/series/$seriesId'
      preLoaderRoute: typeof AuthenticatedPlatformSeriesSeriesIdRouteImport
      parentRoute: typeof AuthenticatedPlatformSeriesRouteRoute
    }
    '/_authenticated/platform/tenants/': {
      id: '/_authenticated/platform/tenants/'
      path: '/'
      fullPath: '/platform/tenants/'
      preLoaderRoute: typeof AuthenticatedPlatformTenantsIndexRouteImport
      parentRoute: typeof AuthenticatedPlatformTenantsRouteRoute
    }
    '/_authenticated/platform/tenants/$tenantId': {
      id: '/_authenticated/platform/tenants/$tenantId'
      path: '/$tenantId'
      fullPath: '/platform/tenants/$tenantId'
      preLoaderRoute: typeof AuthenticatedPlatformTenantsTenantIdRouteRouteImport
      parentRoute: typeof AuthenticatedPlatformTenantsRouteRoute
    }
    '/_authenticated/platform/users/': {
      id: '/_authenticated/platform/users/'
      path: '/'
      fullPath: '/platform/users/'
      preLoaderRoute: typeof AuthenticatedPlatformUsersIndexRouteImport
      parentRoute: typeof AuthenticatedPlatformUsersRouteRoute
    }
    '/_authenticated/platform/users/$userId': {
      id: '/_authenticated/platform/users/$userId'
      path: '/$userId'
      fullPath: '/platform/users/$userId'
      preLoaderRoute: typeof AuthenticatedPlatformUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedPlatformUsersRouteRoute
    }
    '/_authenticated/ticketing/registrations/': {
      id: '/_authenticated/ticketing/registrations/'
      path: '/'
      fullPath: '/ticketing/registrations/'
      preLoaderRoute: typeof AuthenticatedTicketingRegistrationsIndexRouteImport
      parentRoute: typeof AuthenticatedTicketingRegistrationsRouteRoute
    }
    '/_authenticated/ticketing/registrations/$registrationId': {
      id: '/_authenticated/ticketing/registrations/$registrationId'
      path: '/$registrationId'
      fullPath: '/ticketing/registrations/$registrationId'
      preLoaderRoute: typeof AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteImport
      parentRoute: typeof AuthenticatedTicketingRegistrationsRouteRoute
    }
    '/_authenticated/ticketing/registrations/import': {
      id: '/_authenticated/ticketing/registrations/import'
      path: '/import'
      fullPath: '/ticketing/registrations/import'
      preLoaderRoute: typeof AuthenticatedTicketingRegistrationsImportRouteImport
      parentRoute: typeof AuthenticatedTicketingRegistrationsRouteRoute
    }
    '/_authenticated/exhibition/exhibitors/$applicationId/': {
      id: '/_authenticated/exhibition/exhibitors/$applicationId/'
      path: '/'
      fullPath: '/exhibition/exhibitors/$applicationId/'
      preLoaderRoute: typeof AuthenticatedExhibitionExhibitorsApplicationIdIndexRouteImport
      parentRoute: typeof AuthenticatedExhibitionExhibitorsApplicationIdRouteRoute
    }
    '/_authenticated/exhibition/service-orders/$serviceOrderId_/edit': {
      id: '/_authenticated/exhibition/service-orders/$serviceOrderId_/edit'
      path: '/$serviceOrderId/edit'
      fullPath: '/exhibition/service-orders/$serviceOrderId/edit'
      preLoaderRoute: typeof AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRouteImport
      parentRoute: typeof AuthenticatedExhibitionServiceOrdersRouteRoute
    }
    '/_authenticated/platform/tenants/$tenantId/': {
      id: '/_authenticated/platform/tenants/$tenantId/'
      path: '/'
      fullPath: '/platform/tenants/$tenantId/'
      preLoaderRoute: typeof AuthenticatedPlatformTenantsTenantIdIndexRouteImport
      parentRoute: typeof AuthenticatedPlatformTenantsTenantIdRouteRoute
    }
    '/_authenticated/platform/tenants/$tenantId/activity': {
      id: '/_authenticated/platform/tenants/$tenantId/activity'
      path: '/activity'
      fullPath: '/platform/tenants/$tenantId/activity'
      preLoaderRoute: typeof AuthenticatedPlatformTenantsTenantIdActivityRouteImport
      parentRoute: typeof AuthenticatedPlatformTenantsTenantIdRouteRoute
    }
    '/_authenticated/platform/tenants/$tenantId/domains': {
      id: '/_authenticated/platform/tenants/$tenantId/domains'
      path: '/domains'
      fullPath: '/platform/tenants/$tenantId/domains'
      preLoaderRoute: typeof AuthenticatedPlatformTenantsTenantIdDomainsRouteImport
      parentRoute: typeof AuthenticatedPlatformTenantsTenantIdRouteRoute
    }
    '/_authenticated/platform/tenants/$tenantId/modules': {
      id: '/_authenticated/platform/tenants/$tenantId/modules'
      path: '/modules'
      fullPath: '/platform/tenants/$tenantId/modules'
      preLoaderRoute: typeof AuthenticatedPlatformTenantsTenantIdModulesRouteImport
      parentRoute: typeof AuthenticatedPlatformTenantsTenantIdRouteRoute
    }
    '/_authenticated/platform/tenants/$tenantId/usage': {
      id: '/_authenticated/platform/tenants/$tenantId/usage'
      path: '/usage'
      fullPath: '/platform/tenants/$tenantId/usage'
      preLoaderRoute: typeof AuthenticatedPlatformTenantsTenantIdUsageRouteImport
      parentRoute: typeof AuthenticatedPlatformTenantsTenantIdRouteRoute
    }
    '/_authenticated/ticketing/registrations/$registrationId/': {
      id: '/_authenticated/ticketing/registrations/$registrationId/'
      path: '/'
      fullPath: '/ticketing/registrations/$registrationId/'
      preLoaderRoute: typeof AuthenticatedTicketingRegistrationsRegistrationIdIndexRouteImport
      parentRoute: typeof AuthenticatedTicketingRegistrationsRegistrationIdRouteRoute
    }
    '/_authenticated/ticketing/registrations/$registrationId/add-participants': {
      id: '/_authenticated/ticketing/registrations/$registrationId/add-participants'
      path: '/add-participants'
      fullPath: '/ticketing/registrations/$registrationId/add-participants'
      preLoaderRoute: typeof AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRouteImport
      parentRoute: typeof AuthenticatedTicketingRegistrationsRegistrationIdRouteRoute
    }
  }
}

interface AuthenticatedPlatformPlansRouteRouteChildren {
  AuthenticatedPlatformPlansPlanIdRoute: typeof AuthenticatedPlatformPlansPlanIdRoute
  AuthenticatedPlatformPlansIndexRoute: typeof AuthenticatedPlatformPlansIndexRoute
}

const AuthenticatedPlatformPlansRouteRouteChildren: AuthenticatedPlatformPlansRouteRouteChildren =
  {
    AuthenticatedPlatformPlansPlanIdRoute:
      AuthenticatedPlatformPlansPlanIdRoute,
    AuthenticatedPlatformPlansIndexRoute: AuthenticatedPlatformPlansIndexRoute,
  }

const AuthenticatedPlatformPlansRouteRouteWithChildren =
  AuthenticatedPlatformPlansRouteRoute._addFileChildren(
    AuthenticatedPlatformPlansRouteRouteChildren,
  )

interface AuthenticatedPlatformSeriesRouteRouteChildren {
  AuthenticatedPlatformSeriesSeriesIdRoute: typeof AuthenticatedPlatformSeriesSeriesIdRoute
  AuthenticatedPlatformSeriesIndexRoute: typeof AuthenticatedPlatformSeriesIndexRoute
}

const AuthenticatedPlatformSeriesRouteRouteChildren: AuthenticatedPlatformSeriesRouteRouteChildren =
  {
    AuthenticatedPlatformSeriesSeriesIdRoute:
      AuthenticatedPlatformSeriesSeriesIdRoute,
    AuthenticatedPlatformSeriesIndexRoute:
      AuthenticatedPlatformSeriesIndexRoute,
  }

const AuthenticatedPlatformSeriesRouteRouteWithChildren =
  AuthenticatedPlatformSeriesRouteRoute._addFileChildren(
    AuthenticatedPlatformSeriesRouteRouteChildren,
  )

interface AuthenticatedPlatformTenantsTenantIdRouteRouteChildren {
  AuthenticatedPlatformTenantsTenantIdActivityRoute: typeof AuthenticatedPlatformTenantsTenantIdActivityRoute
  AuthenticatedPlatformTenantsTenantIdDomainsRoute: typeof AuthenticatedPlatformTenantsTenantIdDomainsRoute
  AuthenticatedPlatformTenantsTenantIdModulesRoute: typeof AuthenticatedPlatformTenantsTenantIdModulesRoute
  AuthenticatedPlatformTenantsTenantIdUsageRoute: typeof AuthenticatedPlatformTenantsTenantIdUsageRoute
  AuthenticatedPlatformTenantsTenantIdIndexRoute: typeof AuthenticatedPlatformTenantsTenantIdIndexRoute
}

const AuthenticatedPlatformTenantsTenantIdRouteRouteChildren: AuthenticatedPlatformTenantsTenantIdRouteRouteChildren =
  {
    AuthenticatedPlatformTenantsTenantIdActivityRoute:
      AuthenticatedPlatformTenantsTenantIdActivityRoute,
    AuthenticatedPlatformTenantsTenantIdDomainsRoute:
      AuthenticatedPlatformTenantsTenantIdDomainsRoute,
    AuthenticatedPlatformTenantsTenantIdModulesRoute:
      AuthenticatedPlatformTenantsTenantIdModulesRoute,
    AuthenticatedPlatformTenantsTenantIdUsageRoute:
      AuthenticatedPlatformTenantsTenantIdUsageRoute,
    AuthenticatedPlatformTenantsTenantIdIndexRoute:
      AuthenticatedPlatformTenantsTenantIdIndexRoute,
  }

const AuthenticatedPlatformTenantsTenantIdRouteRouteWithChildren =
  AuthenticatedPlatformTenantsTenantIdRouteRoute._addFileChildren(
    AuthenticatedPlatformTenantsTenantIdRouteRouteChildren,
  )

interface AuthenticatedPlatformTenantsRouteRouteChildren {
  AuthenticatedPlatformTenantsTenantIdRouteRoute: typeof AuthenticatedPlatformTenantsTenantIdRouteRouteWithChildren
  AuthenticatedPlatformTenantsIndexRoute: typeof AuthenticatedPlatformTenantsIndexRoute
}

const AuthenticatedPlatformTenantsRouteRouteChildren: AuthenticatedPlatformTenantsRouteRouteChildren =
  {
    AuthenticatedPlatformTenantsTenantIdRouteRoute:
      AuthenticatedPlatformTenantsTenantIdRouteRouteWithChildren,
    AuthenticatedPlatformTenantsIndexRoute:
      AuthenticatedPlatformTenantsIndexRoute,
  }

const AuthenticatedPlatformTenantsRouteRouteWithChildren =
  AuthenticatedPlatformTenantsRouteRoute._addFileChildren(
    AuthenticatedPlatformTenantsRouteRouteChildren,
  )

interface AuthenticatedPlatformUsersRouteRouteChildren {
  AuthenticatedPlatformUsersUserIdRoute: typeof AuthenticatedPlatformUsersUserIdRoute
  AuthenticatedPlatformUsersIndexRoute: typeof AuthenticatedPlatformUsersIndexRoute
}

const AuthenticatedPlatformUsersRouteRouteChildren: AuthenticatedPlatformUsersRouteRouteChildren =
  {
    AuthenticatedPlatformUsersUserIdRoute:
      AuthenticatedPlatformUsersUserIdRoute,
    AuthenticatedPlatformUsersIndexRoute: AuthenticatedPlatformUsersIndexRoute,
  }

const AuthenticatedPlatformUsersRouteRouteWithChildren =
  AuthenticatedPlatformUsersRouteRoute._addFileChildren(
    AuthenticatedPlatformUsersRouteRouteChildren,
  )

interface AuthenticatedPlatformRouteRouteChildren {
  AuthenticatedPlatformPlansRouteRoute: typeof AuthenticatedPlatformPlansRouteRouteWithChildren
  AuthenticatedPlatformSeriesRouteRoute: typeof AuthenticatedPlatformSeriesRouteRouteWithChildren
  AuthenticatedPlatformTenantsRouteRoute: typeof AuthenticatedPlatformTenantsRouteRouteWithChildren
  AuthenticatedPlatformUsersRouteRoute: typeof AuthenticatedPlatformUsersRouteRouteWithChildren
  AuthenticatedPlatformActivityRoute: typeof AuthenticatedPlatformActivityRoute
  AuthenticatedPlatformPaymentMethodsRoute: typeof AuthenticatedPlatformPaymentMethodsRoute
  AuthenticatedPlatformUsageRoute: typeof AuthenticatedPlatformUsageRoute
  AuthenticatedPlatformIndexRoute: typeof AuthenticatedPlatformIndexRoute
}

const AuthenticatedPlatformRouteRouteChildren: AuthenticatedPlatformRouteRouteChildren =
  {
    AuthenticatedPlatformPlansRouteRoute:
      AuthenticatedPlatformPlansRouteRouteWithChildren,
    AuthenticatedPlatformSeriesRouteRoute:
      AuthenticatedPlatformSeriesRouteRouteWithChildren,
    AuthenticatedPlatformTenantsRouteRoute:
      AuthenticatedPlatformTenantsRouteRouteWithChildren,
    AuthenticatedPlatformUsersRouteRoute:
      AuthenticatedPlatformUsersRouteRouteWithChildren,
    AuthenticatedPlatformActivityRoute: AuthenticatedPlatformActivityRoute,
    AuthenticatedPlatformPaymentMethodsRoute:
      AuthenticatedPlatformPaymentMethodsRoute,
    AuthenticatedPlatformUsageRoute: AuthenticatedPlatformUsageRoute,
    AuthenticatedPlatformIndexRoute: AuthenticatedPlatformIndexRoute,
  }

const AuthenticatedPlatformRouteRouteWithChildren =
  AuthenticatedPlatformRouteRoute._addFileChildren(
    AuthenticatedPlatformRouteRouteChildren,
  )

interface AuthenticatedBillingInvoicesRouteRouteChildren {
  AuthenticatedBillingInvoicesInvoiceIdRoute: typeof AuthenticatedBillingInvoicesInvoiceIdRoute
  AuthenticatedBillingInvoicesIndexRoute: typeof AuthenticatedBillingInvoicesIndexRoute
}

const AuthenticatedBillingInvoicesRouteRouteChildren: AuthenticatedBillingInvoicesRouteRouteChildren =
  {
    AuthenticatedBillingInvoicesInvoiceIdRoute:
      AuthenticatedBillingInvoicesInvoiceIdRoute,
    AuthenticatedBillingInvoicesIndexRoute:
      AuthenticatedBillingInvoicesIndexRoute,
  }

const AuthenticatedBillingInvoicesRouteRouteWithChildren =
  AuthenticatedBillingInvoicesRouteRoute._addFileChildren(
    AuthenticatedBillingInvoicesRouteRouteChildren,
  )

interface AuthenticatedBillingPaymentsRouteRouteChildren {
  AuthenticatedBillingPaymentsPaymentIdRoute: typeof AuthenticatedBillingPaymentsPaymentIdRoute
  AuthenticatedBillingPaymentsIndexRoute: typeof AuthenticatedBillingPaymentsIndexRoute
}

const AuthenticatedBillingPaymentsRouteRouteChildren: AuthenticatedBillingPaymentsRouteRouteChildren =
  {
    AuthenticatedBillingPaymentsPaymentIdRoute:
      AuthenticatedBillingPaymentsPaymentIdRoute,
    AuthenticatedBillingPaymentsIndexRoute:
      AuthenticatedBillingPaymentsIndexRoute,
  }

const AuthenticatedBillingPaymentsRouteRouteWithChildren =
  AuthenticatedBillingPaymentsRouteRoute._addFileChildren(
    AuthenticatedBillingPaymentsRouteRouteChildren,
  )

interface AuthenticatedCmsContentRouteRouteChildren {
  AuthenticatedCmsContentIdRoute: typeof AuthenticatedCmsContentIdRoute
  AuthenticatedCmsContentIndexRoute: typeof AuthenticatedCmsContentIndexRoute
}

const AuthenticatedCmsContentRouteRouteChildren: AuthenticatedCmsContentRouteRouteChildren =
  {
    AuthenticatedCmsContentIdRoute: AuthenticatedCmsContentIdRoute,
    AuthenticatedCmsContentIndexRoute: AuthenticatedCmsContentIndexRoute,
  }

const AuthenticatedCmsContentRouteRouteWithChildren =
  AuthenticatedCmsContentRouteRoute._addFileChildren(
    AuthenticatedCmsContentRouteRouteChildren,
  )

interface AuthenticatedExhibitionCompaniesRouteRouteChildren {
  AuthenticatedExhibitionCompaniesCompanyIdRoute: typeof AuthenticatedExhibitionCompaniesCompanyIdRoute
  AuthenticatedExhibitionCompaniesIndexRoute: typeof AuthenticatedExhibitionCompaniesIndexRoute
}

const AuthenticatedExhibitionCompaniesRouteRouteChildren: AuthenticatedExhibitionCompaniesRouteRouteChildren =
  {
    AuthenticatedExhibitionCompaniesCompanyIdRoute:
      AuthenticatedExhibitionCompaniesCompanyIdRoute,
    AuthenticatedExhibitionCompaniesIndexRoute:
      AuthenticatedExhibitionCompaniesIndexRoute,
  }

const AuthenticatedExhibitionCompaniesRouteRouteWithChildren =
  AuthenticatedExhibitionCompaniesRouteRoute._addFileChildren(
    AuthenticatedExhibitionCompaniesRouteRouteChildren,
  )

interface AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteChildren {
  AuthenticatedExhibitionExhibitorsApplicationIdIndexRoute: typeof AuthenticatedExhibitionExhibitorsApplicationIdIndexRoute
}

const AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteChildren: AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteChildren =
  {
    AuthenticatedExhibitionExhibitorsApplicationIdIndexRoute:
      AuthenticatedExhibitionExhibitorsApplicationIdIndexRoute,
  }

const AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteWithChildren =
  AuthenticatedExhibitionExhibitorsApplicationIdRouteRoute._addFileChildren(
    AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteChildren,
  )

interface AuthenticatedExhibitionExhibitorsRouteRouteChildren {
  AuthenticatedExhibitionExhibitorsApplicationIdRouteRoute: typeof AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteWithChildren
  AuthenticatedExhibitionExhibitorsNewRoute: typeof AuthenticatedExhibitionExhibitorsNewRoute
  AuthenticatedExhibitionExhibitorsIndexRoute: typeof AuthenticatedExhibitionExhibitorsIndexRoute
}

const AuthenticatedExhibitionExhibitorsRouteRouteChildren: AuthenticatedExhibitionExhibitorsRouteRouteChildren =
  {
    AuthenticatedExhibitionExhibitorsApplicationIdRouteRoute:
      AuthenticatedExhibitionExhibitorsApplicationIdRouteRouteWithChildren,
    AuthenticatedExhibitionExhibitorsNewRoute:
      AuthenticatedExhibitionExhibitorsNewRoute,
    AuthenticatedExhibitionExhibitorsIndexRoute:
      AuthenticatedExhibitionExhibitorsIndexRoute,
  }

const AuthenticatedExhibitionExhibitorsRouteRouteWithChildren =
  AuthenticatedExhibitionExhibitorsRouteRoute._addFileChildren(
    AuthenticatedExhibitionExhibitorsRouteRouteChildren,
  )

interface AuthenticatedExhibitionServiceOrdersRouteRouteChildren {
  AuthenticatedExhibitionServiceOrdersServiceOrderIdRoute: typeof AuthenticatedExhibitionServiceOrdersServiceOrderIdRoute
  AuthenticatedExhibitionServiceOrdersNewRoute: typeof AuthenticatedExhibitionServiceOrdersNewRoute
  AuthenticatedExhibitionServiceOrdersIndexRoute: typeof AuthenticatedExhibitionServiceOrdersIndexRoute
  AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRoute: typeof AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRoute
}

const AuthenticatedExhibitionServiceOrdersRouteRouteChildren: AuthenticatedExhibitionServiceOrdersRouteRouteChildren =
  {
    AuthenticatedExhibitionServiceOrdersServiceOrderIdRoute:
      AuthenticatedExhibitionServiceOrdersServiceOrderIdRoute,
    AuthenticatedExhibitionServiceOrdersNewRoute:
      AuthenticatedExhibitionServiceOrdersNewRoute,
    AuthenticatedExhibitionServiceOrdersIndexRoute:
      AuthenticatedExhibitionServiceOrdersIndexRoute,
    AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRoute:
      AuthenticatedExhibitionServiceOrdersServiceOrderIdEditRoute,
  }

const AuthenticatedExhibitionServiceOrdersRouteRouteWithChildren =
  AuthenticatedExhibitionServiceOrdersRouteRoute._addFileChildren(
    AuthenticatedExhibitionServiceOrdersRouteRouteChildren,
  )

interface AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteChildren {
  AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRoute: typeof AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRoute
  AuthenticatedTicketingRegistrationsRegistrationIdIndexRoute: typeof AuthenticatedTicketingRegistrationsRegistrationIdIndexRoute
}

const AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteChildren: AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteChildren =
  {
    AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRoute:
      AuthenticatedTicketingRegistrationsRegistrationIdAddParticipantsRoute,
    AuthenticatedTicketingRegistrationsRegistrationIdIndexRoute:
      AuthenticatedTicketingRegistrationsRegistrationIdIndexRoute,
  }

const AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteWithChildren =
  AuthenticatedTicketingRegistrationsRegistrationIdRouteRoute._addFileChildren(
    AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteChildren,
  )

interface AuthenticatedTicketingRegistrationsRouteRouteChildren {
  AuthenticatedTicketingRegistrationsRegistrationIdRouteRoute: typeof AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteWithChildren
  AuthenticatedTicketingRegistrationsImportRoute: typeof AuthenticatedTicketingRegistrationsImportRoute
  AuthenticatedTicketingRegistrationsIndexRoute: typeof AuthenticatedTicketingRegistrationsIndexRoute
}

const AuthenticatedTicketingRegistrationsRouteRouteChildren: AuthenticatedTicketingRegistrationsRouteRouteChildren =
  {
    AuthenticatedTicketingRegistrationsRegistrationIdRouteRoute:
      AuthenticatedTicketingRegistrationsRegistrationIdRouteRouteWithChildren,
    AuthenticatedTicketingRegistrationsImportRoute:
      AuthenticatedTicketingRegistrationsImportRoute,
    AuthenticatedTicketingRegistrationsIndexRoute:
      AuthenticatedTicketingRegistrationsIndexRoute,
  }

const AuthenticatedTicketingRegistrationsRouteRouteWithChildren =
  AuthenticatedTicketingRegistrationsRouteRoute._addFileChildren(
    AuthenticatedTicketingRegistrationsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedPlatformRouteRoute: typeof AuthenticatedPlatformRouteRouteWithChildren
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedBillingInvoicesRouteRoute: typeof AuthenticatedBillingInvoicesRouteRouteWithChildren
  AuthenticatedBillingPaymentsRouteRoute: typeof AuthenticatedBillingPaymentsRouteRouteWithChildren
  AuthenticatedCmsContentRouteRoute: typeof AuthenticatedCmsContentRouteRouteWithChildren
  AuthenticatedExhibitionCompaniesRouteRoute: typeof AuthenticatedExhibitionCompaniesRouteRouteWithChildren
  AuthenticatedExhibitionExhibitorsRouteRoute: typeof AuthenticatedExhibitionExhibitorsRouteRouteWithChildren
  AuthenticatedExhibitionServiceOrdersRouteRoute: typeof AuthenticatedExhibitionServiceOrdersRouteRouteWithChildren
  AuthenticatedTicketingRegistrationsRouteRoute: typeof AuthenticatedTicketingRegistrationsRouteRouteWithChildren
  AuthenticatedBillingCreditNotesRoute: typeof AuthenticatedBillingCreditNotesRoute
  AuthenticatedBillingExchangeRatesRoute: typeof AuthenticatedBillingExchangeRatesRoute
  AuthenticatedBillingPaymentMethodsRoute: typeof AuthenticatedBillingPaymentMethodsRoute
  AuthenticatedCmsMediaRoute: typeof AuthenticatedCmsMediaRoute
  AuthenticatedExhibitionFloorRoute: typeof AuthenticatedExhibitionFloorRoute
  AuthenticatedExhibitionServiceItemsRoute: typeof AuthenticatedExhibitionServiceItemsRoute
  AuthenticatedExhibitionServiceTermsRoute: typeof AuthenticatedExhibitionServiceTermsRoute
  AuthenticatedProgramMeetingsRoute: typeof AuthenticatedProgramMeetingsRoute
  AuthenticatedProgramRoomsRoute: typeof AuthenticatedProgramRoomsRoute
  AuthenticatedProgramSessionsRoute: typeof AuthenticatedProgramSessionsRoute
  AuthenticatedProgramSpeakersRoute: typeof AuthenticatedProgramSpeakersRoute
  AuthenticatedSettingsMembersRoute: typeof AuthenticatedSettingsMembersRoute
  AuthenticatedSettingsOrganizationRoute: typeof AuthenticatedSettingsOrganizationRoute
  AuthenticatedSettingsRolesRoute: typeof AuthenticatedSettingsRolesRoute
  AuthenticatedSettingsThemeRoute: typeof AuthenticatedSettingsThemeRoute
  AuthenticatedTicketingCheckInRoute: typeof AuthenticatedTicketingCheckInRoute
  AuthenticatedTicketingDeskRoute: typeof AuthenticatedTicketingDeskRoute
  AuthenticatedTicketingRegistrationFormRoute: typeof AuthenticatedTicketingRegistrationFormRoute
  AuthenticatedTicketingTicketTypesRoute: typeof AuthenticatedTicketingTicketTypesRoute
  AuthenticatedTicketingVouchersRoute: typeof AuthenticatedTicketingVouchersRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedVotingIndexRoute: typeof AuthenticatedVotingIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedPlatformRouteRoute: AuthenticatedPlatformRouteRouteWithChildren,
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedBillingInvoicesRouteRoute:
    AuthenticatedBillingInvoicesRouteRouteWithChildren,
  AuthenticatedBillingPaymentsRouteRoute:
    AuthenticatedBillingPaymentsRouteRouteWithChildren,
  AuthenticatedCmsContentRouteRoute:
    AuthenticatedCmsContentRouteRouteWithChildren,
  AuthenticatedExhibitionCompaniesRouteRoute:
    AuthenticatedExhibitionCompaniesRouteRouteWithChildren,
  AuthenticatedExhibitionExhibitorsRouteRoute:
    AuthenticatedExhibitionExhibitorsRouteRouteWithChildren,
  AuthenticatedExhibitionServiceOrdersRouteRoute:
    AuthenticatedExhibitionServiceOrdersRouteRouteWithChildren,
  AuthenticatedTicketingRegistrationsRouteRoute:
    AuthenticatedTicketingRegistrationsRouteRouteWithChildren,
  AuthenticatedBillingCreditNotesRoute: AuthenticatedBillingCreditNotesRoute,
  AuthenticatedBillingExchangeRatesRoute:
    AuthenticatedBillingExchangeRatesRoute,
  AuthenticatedBillingPaymentMethodsRoute:
    AuthenticatedBillingPaymentMethodsRoute,
  AuthenticatedCmsMediaRoute: AuthenticatedCmsMediaRoute,
  AuthenticatedExhibitionFloorRoute: AuthenticatedExhibitionFloorRoute,
  AuthenticatedExhibitionServiceItemsRoute:
    AuthenticatedExhibitionServiceItemsRoute,
  AuthenticatedExhibitionServiceTermsRoute:
    AuthenticatedExhibitionServiceTermsRoute,
  AuthenticatedProgramMeetingsRoute: AuthenticatedProgramMeetingsRoute,
  AuthenticatedProgramRoomsRoute: AuthenticatedProgramRoomsRoute,
  AuthenticatedProgramSessionsRoute: AuthenticatedProgramSessionsRoute,
  AuthenticatedProgramSpeakersRoute: AuthenticatedProgramSpeakersRoute,
  AuthenticatedSettingsMembersRoute: AuthenticatedSettingsMembersRoute,
  AuthenticatedSettingsOrganizationRoute:
    AuthenticatedSettingsOrganizationRoute,
  AuthenticatedSettingsRolesRoute: AuthenticatedSettingsRolesRoute,
  AuthenticatedSettingsThemeRoute: AuthenticatedSettingsThemeRoute,
  AuthenticatedTicketingCheckInRoute: AuthenticatedTicketingCheckInRoute,
  AuthenticatedTicketingDeskRoute: AuthenticatedTicketingDeskRoute,
  AuthenticatedTicketingRegistrationFormRoute:
    AuthenticatedTicketingRegistrationFormRoute,
  AuthenticatedTicketingTicketTypesRoute:
    AuthenticatedTicketingTicketTypesRoute,
  AuthenticatedTicketingVouchersRoute: AuthenticatedTicketingVouchersRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedVotingIndexRoute: AuthenticatedVotingIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  publicLoginRoute: publicLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
